/**
 * Adjust all of the ordinals in a datasource in order to correctly reorder it.
 *
 * The datasource will not be sorted after the re-order.  Only models in the datasource will be changed.
 *
 * @param ds The datasource to work on
 * @param from 0-based ordinal.  The item to re-order.
 * @param to 0-based ordinal target. Can be -1 to force to the front of the list.
 * @param ordinalField The ordinal field. Defaults to "ordinal".
 * @param zeroOffset The starting ordinal.  Defaults to 0
 * @param insertAfter true if item should be inserted after to. false if item should inserted before to. Default = from < to.
 */
export default function(ds, from, to, ordinalField, zeroOffset, insertAfter, set = false) {
    ordinalField = ordinalField !== undefined ? ordinalField : "ordinal";
    zeroOffset = zeroOffset !== undefined ? zeroOffset : 0;
    from = Number(from) + zeroOffset;
    to = Number(to) + zeroOffset;
    var sortTo;
    insertAfter = insertAfter === undefined ? from < to : insertAfter;
    sortTo = insertAfter ? to + 0.5 : to - 0.5;

    var sortOrd = function(item) {
        if (item[ordinalField] == from) {
            return sortTo;
        } else {
            return item[ordinalField];
        }
    };

    ds.data().slice(0)
        .sort(function(a, b) {
            return sortOrd(a) - sortOrd(b);
        })
        .forEach(function(item, index) {
            var targetOrd = index + zeroOffset;
            if (item[ordinalField] !== targetOrd) {
                if(set) {
                    item.set(ordinalField, targetOrd);
                } else {
                    item[ordinalField] = targetOrd;
                    item.dirty = true;
                }
            }
        });
}
